
export const conditionFields = {
    success: true,
    context: {
        requestId: '7937f755-0c3f-4c74-8cfa-4baf4ef3377d',
        correlationId: '1c83a5b5-2c00-4523-bfd3-e09007a6a4ac',
    },
    data: [],
};

// New Editor Json
export const EditorConfig = {
    AR: {
        CC: {
            MARLBORO: {
                data: [
                    {
                        nbaEntityId: 17,
                        name: 'asset',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 53,
                                name: 'id',
                                valueOption: null,
                                supportedOperation: 'equals',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 54,
                                name: 'type',
                                valueOption: 'Game,Video,Article,Quiz,Raffle,Story',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 55,
                                name: 'category',
                                valueOption: null,
                                supportedOperation: 'equals',
                                attributeType: 'string',
                            },
                        ],
                    },
                    {
                        nbaEntityId: 19,
                        name: 'profile',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 57,
                                name: 'register',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 58,
                                name: 'login',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 59,
                                name: 'completeProfile',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },

                            {
                                nbaEntityAttributeId: 60,
                                name: 'loginFrequency',
                                valueOption: 'daily,weekly,monthly,yearly',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 61,
                                name: 'loginCount',
                                valueOption: null,
                                supportedOperation:
                                    '<,<=,=,>,>=,!=,between_numbers,not_between_numbers',
                                attributeType: 'integer',
                            },
                            {
                                nbaEntityAttributeId: 62,
                                name: 'consumerPoints',
                                valueOption: null,
                                supportedOperation:
                                    '<,<=,=,>,>=,!=,between_numbers,not_between_numbers',
                                attributeType: 'integer',
                            },
                            {
                                nbaEntityAttributeId: 63,
                                name: 'consumerTier',
                                valueOption: 'bronze,silver,gold',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                        ],
                    },
                ],
            },
        },
    },
    EG: {
        CC: {
            MARLBORO: {
                data: [
                    {
                        nbaEntityId: 17,
                        name: 'asset',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 53,
                                name: 'id',
                                valueOption: null,
                                supportedOperation: 'equals',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 54,
                                name: 'type',
                                valueOption: 'Video,Image,Swiper,Game,Form,Quiz,SpinWheel',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 55,
                                name: 'category',
                                valueOption: null,
                                supportedOperation: 'equals',
                                attributeType: 'string',
                            },
                        ],
                    },
                    {
                        nbaEntityId: 19,
                        name: 'profile',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 58,
                                name: 'login',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 60,
                                name: 'loginFrequency',
                                valueOption: 'daily',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 61,
                                name: 'loginCount',
                                valueOption: null,
                                supportedOperation:
                                    '=,>=',
                                attributeType: 'integer',
                            },
                        ],
                    },
                ],
            },
            LM: {
                data: [
                    {
                        nbaEntityId: 17,
                        name: 'asset',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 53,
                                name: 'id',
                                valueOption: null,
                                supportedOperation: 'equals',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 54,
                                name: 'type',
                                valueOption: 'Video,Image,Swiper,Game,Form,Quiz,SpinWheel',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 55,
                                name: 'category',
                                valueOption: null,
                                supportedOperation: 'equals',
                                attributeType: 'string',
                            },
                        ],
                    },
                    {
                        nbaEntityId: 19,
                        name: 'profile',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 58,
                                name: 'login',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 60,
                                name: 'loginFrequency',
                                valueOption: 'daily',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 61,
                                name: 'loginCount',
                                valueOption: null,
                                supportedOperation:
                                    '=,>=',
                                attributeType: 'integer',
                            },
                        ],
                    },
                ],
            },
        },
    },
    PH: {
        CC: {
            FORTUNE: {
                data: [
                    {
                        nbaEntityId: 17,
                        name: 'asset',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 53,
                                name: 'id',
                                valueOption: null,
                                supportedOperation: 'equals',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 54,
                                name: 'type',
                                valueOption: 'Game,Video,Article,Quiz,Raffle',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 55,
                                name: 'category',
                                valueOption: null,
                                supportedOperation: 'equals',
                                attributeType: 'string',
                            },
                        ],
                    },
                    {
                        nbaEntityId: 18,
                        name: 'upc',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 56,
                                name: 'skuCode',
                                valueOption: '40.9H1G,40.9N6D,40.9R32,40.9UVX,40.9K80,40.9NWJ,40.9RRA,40.9SMW,40.9UW0,40.A14F,40.0JYB,40.0ZP1,40.9GP1,40.9H1F,40.9H1H,40.9N6C,40.9N6F,40.9NW1,40.9NWK,40.9NWM,40.9R33,40.9R34,40.9UVY,40.A14G,40.9D3W,40.9GNX,40.9ZWR,40.A15A,40.A14M,40.A7FB,40.A7FA,40.ACKS,40.ACKR,40.A3ZY,40.A3ZU,40.C01T,40.C01V,40.AE18,49.0A0L,49.0A0M,49.0A0R,49.0A0S,49.0A0T,49.0A0U',
                                supportedOperation: '==,is_multiple',
                                attributeType: 'string',
                            },
                        ],
                    },
                    {
                        nbaEntityId: 19,
                        name: 'profile',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 57,
                                name: 'register',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 58,
                                name: 'login',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 59,
                                name: 'completeProfile',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },

                            {
                                nbaEntityAttributeId: 60,
                                name: 'loginFrequency',
                                valueOption: 'daily,weekly,monthly,yearly',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 61,
                                name: 'loginCount',
                                valueOption: null,
                                supportedOperation:
                                    '<,<=,=,>,>=,!=,between_numbers,not_between_numbers',
                                attributeType: 'integer',
                            },
                            {
                                nbaEntityAttributeId: 62,
                                name: 'consumerPoints',
                                valueOption: null,
                                supportedOperation:
                                    '<,<=,=,>,>=,!=,between_numbers,not_between_numbers',
                                attributeType: 'integer',
                            },
                            {
                                nbaEntityAttributeId: 63,
                                name: 'consumerTier',
                                valueOption: 'bronze,silver,gold',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 64,
                                name: 'isReferral',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 65,
                                name: 'isUpcUploaded',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            // {
                            //     nbaEntityAttributeId: 67,
                            //     name: 'preferredLanguage',
                            //     valueOption: 'EN',
                            //     supportedOperation: '==',
                            //     attributeType: 'string',
                            // },
                            // {
                            //     nbaEntityAttributeId: 68,
                            //     name: 'registrationBrand',
                            //     valueOption: 'FORTE,MARLB,CHEST,PHILI',
                            //     supportedOperation: '==',
                            //     attributeType: 'string',
                            // },
                            // {
                            //     nbaEntityAttributeId: 69,
                            //     name: 'channelRefCode',
                            //     valueOption: null,
                            //     supportedOperation: 'equals',
                            //     attributeType: 'string',
                            // },
                            // {
                            //     nbaEntityAttributeId: 70,
                            //     name: 'registrationDate',
                            //     valueOption: null,
                            //     supportedOperation:
                            //         'after,before,on_or_after,on_or_before,on,not_on,between_dates,not_between_dates,between_period,not_between_period,within_this,not_within_this',
                            //     attributeType: 'date',
                            // },
                            // {
                            //     nbaEntityAttributeId: 71,
                            //     name: 'profileVerified',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                            // {
                            //     nbaEntityAttributeId: 72,
                            //     name: 'isActive',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                            // {
                            //     nbaEntityAttributeId: 73,
                            //     name: 'privacyPolicy',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                            // {
                            //     nbaEntityAttributeId: 74,
                            //     name: 'databaseOptIn',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                            // {
                            //     nbaEntityAttributeId: 75,
                            //     name: 'smokerDeclaration',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                            // {
                            //     nbaEntityAttributeId: 76,
                            //     name: 'marketingOptIn',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                            // {
                            //     nbaEntityAttributeId: 77,
                            //     name: 'brandsOptIn',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                            // {
                            //     nbaEntityAttributeId: 78,
                            //     name: 'smsOptIn',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                            // {
                            //     nbaEntityAttributeId: 79,
                            //     name: 'dmOptIn',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                            // {
                            //     nbaEntityAttributeId: 80,
                            //     name: 'callOptin',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },

                            {
                                nbaEntityAttributeId: 81,
                                name: 'verifiedByIdMatch',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            // {
                            //     nbaEntityAttributeId: 82,
                            //     name: 'verifiedByDataMatch',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                            // {
                            //     nbaEntityAttributeId: 83,
                            //     name: 'verifiedByFACECAPTURE',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                            // {
                            //     nbaEntityAttributeId: 84,
                            //     name: 'verifiedByF2F',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                        ],
                    },
                    {
                        nbaEntityId: 20,
                        name: 'godFather',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 85,
                                name: 'weeklyReferralCount',
                                valueOption: null,
                                supportedOperation:
                                    '<,<=,=,>,>=,!=,between_numbers,not_between_numbers',
                                attributeType: 'integer',
                            },
                            {
                                nbaEntityAttributeId: 86,
                                name: 'monthlyReferralCount',
                                valueOption: null,
                                supportedOperation:
                                    '<,<=,=,>,>=,!=,between_numbers,not_between_numbers',
                                attributeType: 'integer',
                            },
                            {
                                nbaEntityAttributeId: 87,
                                name: 'yearlyReferralCount',
                                valueOption: null,
                                supportedOperation:
                                    '<,<=,=,>,>=,!=,between_numbers,not_between_numbers',
                                attributeType: 'integer',
                            },
                            // {
                            //     nbaEntityAttributeId: 88,
                            //     name: 'verifiedByIdMatch',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                            // {
                            //     nbaEntityAttributeId: 89,
                            //     name: 'verifiedByDataMatch',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                            // {
                            //     nbaEntityAttributeId: 90,
                            //     name: 'verifiedByFACECAPTURE',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                            // {
                            //     nbaEntityAttributeId: 91,
                            //     name: 'verifiedByF2F',
                            //     valueOption: 'true,false',
                            //     supportedOperation: '==',
                            //     attributeType: 'boolean',
                            // },
                        ],
                    },
                    {
                        nbaEntityId: 21,
                        name: 'goldenTicket',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 92,
                                name: 'campaignId',
                                valueOption: null,
                                supportedOperation: 'equals',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 93,
                                name: 'campaignDate',
                                valueOption: null,
                                supportedOperation:
                                    'after,before,on_or_after,on_or_before,on,not_on,between_dates,not_between_dates',
                                attributeType: 'date',
                            },
                        ],
                    },
                ],
            },
        },
    },
    ID: {
        CC: {
            MARLBORO: {
                data: [
                    {
                        nbaEntityId: 17,
                        name: 'asset',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 53,
                                name: 'id',
                                valueOption: null,
                                supportedOperation: 'equals',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 54,
                                name: 'type',
                                valueOption: 'Game,Video,Article,Quiz,Raffle',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 55,
                                name: 'category',
                                valueOption: null,
                                supportedOperation: 'equals',
                                attributeType: 'string',
                            },
                        ],
                    },
                    {
                        nbaEntityId: 18,
                        name: 'upc',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 56,
                                name: 'skuCode',
                                valueOption: '40.9H1G,40.9N6D,40.9R32,40.9UVX,40.9K80,40.9NWJ,40.9RRA,40.9SMW,40.9UW0,40.A14F,40.0JYB,40.0ZP1,40.9GP1,40.9H1F,40.9H1H,40.9N6C,40.9N6F,40.9NW1,40.9NWK,40.9NWM,40.9R33,40.9R34,40.9UVY,40.A14G,40.9D3W,40.9GNX,40.9ZWR,40.A15A,40.A14M,40.A7FB,40.A7FA,40.ACKS,40.ACKR,40.A3ZY,40.A3ZU',
                                supportedOperation: '==,is_multiple',
                                attributeType: 'string',
                            },
                        ],
                    },
                    {
                        nbaEntityId: 19,
                        name: 'profile',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 57,
                                name: 'register',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 58,
                                name: 'login',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 59,
                                name: 'completeProfile',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },

                            {
                                nbaEntityAttributeId: 60,
                                name: 'loginFrequency',
                                valueOption: 'daily,weekly,monthly,yearly',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 61,
                                name: 'loginCount',
                                valueOption: null,
                                supportedOperation:
                                    '<,<=,=,>,>=,!=,between_numbers,not_between_numbers',
                                attributeType: 'integer',
                            },
                            {
                                nbaEntityAttributeId: 62,
                                name: 'consumerPoints',
                                valueOption: null,
                                supportedOperation:
                                    '<,<=,=,>,>=,!=,between_numbers,not_between_numbers',
                                attributeType: 'integer',
                            },
                            {
                                nbaEntityAttributeId: 63,
                                name: 'consumerTier',
                                valueOption: 'bronze,silver,gold',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 64,
                                name: 'isReferral',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 65,
                                name: 'isUpcUploaded',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 67,
                                name: 'preferredLanguage',
                                valueOption: 'EN',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 68,
                                name: 'registrationBrand',
                                valueOption: 'FORTE,MARLB,CHEST,PHILI',
                                supportedOperation: '==',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 69,
                                name: 'channelRefCode',
                                valueOption: null,
                                supportedOperation: 'equals',
                                attributeType: 'string',
                            },
                            {
                                nbaEntityAttributeId: 70,
                                name: 'registrationDate',
                                valueOption: null,
                                supportedOperation:
                                    'after,before,on_or_after,on_or_before,on,not_on,between_dates,not_between_dates,between_period,not_between_period,within_this,not_within_this',
                                attributeType: 'date',
                            },
                            {
                                nbaEntityAttributeId: 71,
                                name: 'profileVerified',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 72,
                                name: 'isActive',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 73,
                                name: 'privacyPolicy',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 74,
                                name: 'databaseOptIn',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 75,
                                name: 'smokerDeclaration',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 76,
                                name: 'marketingOptIn',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 77,
                                name: 'brandsOptIn',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 78,
                                name: 'smsOptIn',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 79,
                                name: 'dmOptIn',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 80,
                                name: 'callOptin',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },

                            {
                                nbaEntityAttributeId: 81,
                                name: 'verifiedByIdMatch',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 82,
                                name: 'verifiedByDataMatch',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 83,
                                name: 'verifiedByFACECAPTURE',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 84,
                                name: 'verifiedByF2F',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                        ],
                    },
                    {
                        nbaEntityId: 20,
                        name: 'godFather',
                        parentEntityId: null,
                        entityType: null,
                        nbaEntityAttributes: [
                            {
                                nbaEntityAttributeId: 85,
                                name: 'weeklyReferralCount',
                                valueOption: null,
                                supportedOperation:
                                    '<,<=,=,>,>=,!=,between_numbers,not_between_numbers',
                                attributeType: 'integer',
                            },
                            {
                                nbaEntityAttributeId: 86,
                                name: 'monthlyReferralCount',
                                valueOption: null,
                                supportedOperation:
                                    '<,<=,=,>,>=,!=,between_numbers,not_between_numbers',
                                attributeType: 'integer',
                            },
                            {
                                nbaEntityAttributeId: 87,
                                name: 'yearlyReferralCount',
                                valueOption: null,
                                supportedOperation:
                                    '<,<=,=,>,>=,!=,between_numbers,not_between_numbers',
                                attributeType: 'integer',
                            },
                            {
                                nbaEntityAttributeId: 88,
                                name: 'verifiedByIdMatch',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 89,
                                name: 'verifiedByDataMatch',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 90,
                                name: 'verifiedByFACECAPTURE',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                            {
                                nbaEntityAttributeId: 91,
                                name: 'verifiedByF2F',
                                valueOption: 'true,false',
                                supportedOperation: '==',
                                attributeType: 'boolean',
                            },
                        ],
                    },
                ],
            },
        },
    },
};
